import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Text from 'shopper/components/Text';

import { getTimeTo } from 'lib/date';

import Dropdown from './Dropdown';
import UserProfileInfo from './UserProfileInfo';

const Edited = dynamic(() => import('./Edited'));

const CommentItemHeader = ({
  canBeRecommendedAsReview = true,
  commentDate,
  commentFixed,
  commentId,
  isContentBlocked,
  isEdited,
  isReview,
  userId,
  userName,
  userPhoto,
  userTypeName,
  userUsername,
  onEditCommentClick,
}) => (
  <div className="mb-1 grid gap-y-2">
    <UserProfileInfo
      className="row-start-1"
      isReview={isReview}
      userId={userId}
      userName={userName}
      userPhoto={userPhoto}
      userTypeName={userTypeName}
      userUsername={userUsername}
    />
    <div className="relative row-start-1 ml-auto flex items-center md:gap-4">
      <Text size="size3">{getTimeTo(commentDate)}</Text>
      {!isContentBlocked && (
        <Dropdown
          canBeRecommendedAsReview={canBeRecommendedAsReview}
          commentFixed={commentFixed}
          commentId={commentId}
          isEdited={isEdited}
          isReview={isReview}
          userId={userId}
          onEditCommentClick={onEditCommentClick}
        />
      )}
    </div>
    {isEdited && <Edited className="row-start-2" />}
  </div>
);

CommentItemHeader.propTypes = {
  canBeRecommendedAsReview: PropTypes.bool,
  commentDate: PropTypes.string.isRequired,
  commentFixed: PropTypes.bool.isRequired,
  commentId: PropTypes.number.isRequired,
  isContentBlocked: PropTypes.bool.isRequired,
  isEdited: PropTypes.bool.isRequired,
  isReview: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userTypeName: PropTypes.string.isRequired,
  userUsername: PropTypes.string.isRequired,
  onEditCommentClick: PropTypes.func.isRequired,
};

export default CommentItemHeader;
